<div class="p-6 flex flex-col gap-4 bg-base-100 rounded-box">
  <h2 class="text-lg font-bold">Tickets unwiderruflich löschen</h2>

  <div class="alert alert-error text-sm shadow-lg flex flex-row items-start gap-4">
    <svg xmlns="http://www.w3.org/2000/svg" class="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
    <span
      ><strong>ACHTUNG:</strong> Du bist dabei, <strong>{{ tickets().length }}</strong> Ticket(s) und alle zugehörigen
      Daten (Einsätze, Techniker-Rückmeldungen, Schritte, Einsatz Daten, MT Ergebnis, etc.) unwiderruflich zu
      löschen.</span
    >
  </div>

  @if (tickets().length > 0) {
    <div class="max-h-60 overflow-y-auto border border-base-300 rounded p-2">
      <h3 class="font-bold mb-2">Betroffene Tickets:</h3>
      <ul class="list-none p-0 m-0">
        @for (ticket of tickets(); track ticket) {
          <li class="border-b border-base-200 py-1 last:border-0 text-sm">
            Ticket #{{ ticket.order_nr }} ({{ ticket.project_name }}) - {{ ticket.status_name }}
          </li>
        }
      </ul>
    </div>
  }

  <div class="flex flex-col gap-4">
    <label class="cursor-pointer label justify-start flex gap-4">
      <input type="checkbox" [(ngModel)]="confirmed" class="checkbox checkbox-error" />
      <span class="label-text font-bold text-error"
        >Ich bestätige, dass ich diese Tickets unwiderruflich löschen möchte.</span
      >
    </label>

    <div class="form-control w-full">
      <label class="label">
        <span class="label-text">Anzahl der Tickets zur Bestätigung</span>
      </label>
      <input type="number" [(ngModel)]="inputCount" class="bm-input bm-input-bordered w-full" />
    </div>
  </div>

  <div class="modal-action mt-6">
    <button class="btn" (click)="onCancel()">Abbrechen</button>
    <button class="btn btn-error" [disabled]="!isDeleteEnabled()" (click)="onDelete()">
      <fa-icon [icon]="['fas', 'trash']"></fa-icon> Löschen
    </button>
  </div>
</div>
